module.exports = __webpack_public_path__ + "static/media/stop_child_labour.86efaa92.png";